import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PowerBiEmbedResponse } from 'src/types/client/clients';
@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  getPowerBiEmbedConfig(email: string): Observable<PowerBiEmbedResponse> {
    const url = `${environment.apiConfig.uri}/admin/AdminClientContact/GetPowerBiEmbed`;
    const headers = { 'Content-Type': 'application/json' };

    // Pass email directly as a JSON string in the request body
    return this.http.post<PowerBiEmbedResponse>(url, `"${email}"`, { headers });
  }
}
